import useFriends from '@/hooks/contacts/use-friends';
import useGroups from '@/hooks/contacts/use-groups';

export default function useContacts() {
  const { friends, isLoading: isFriendLoading } = useFriends();
  const { groups, isLoading: isGroupLoading } = useGroups();

  return {
    friends,
    groups,
    isLoading: isFriendLoading || isGroupLoading,
  };
}
